import React, { useEffect } from "react";
import { api } from "../lib/api";
import { Link, useSearchParams } from "react-router-dom";
import { XCircle } from "@phosphor-icons/react";
import SEO from "../components/SEO";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const eventUri = params.get("event_uri") || "";
  const inviteeUri = params.get("invitee_uri") || "";
  const hold = params.get("hold") || "";
  useEffect(() => { if (hold) api.post("/booking/release", { hold }).catch(() => {}); }, [hold]);
  const retryTarget = eventUri && inviteeUri
    ? `/complete-payment?event_uri=${encodeURIComponent(eventUri)}&invitee_uri=${encodeURIComponent(inviteeUri)}`
    : "/enquiry";

  return (
    <div data-testid="payment-cancel-page">
      <SEO title="Payment cancelled" path="/payment/cancel" />
      <section className="bg-cream-100 border-b border-bronze-light/30">
        <div className="container-ccc py-20 max-w-3xl">
          <div className="eyebrow flex items-center gap-2 text-ink-muted">
            <XCircle size={16} weight="fill" /> Payment cancelled
          </div>
          <h1 className="font-serif text-4xl sm:text-5xl mt-4 leading-tight">
            No worries - nothing was charged.
          </h1>
          <p className="mt-6 text-ink-muted text-lg leading-relaxed">
            {hold
              ? "You closed the checkout before completing payment, so nothing has been booked and your chosen time has been released. You can pick a time again whenever you're ready."
              : "You closed the checkout before completing payment. Your slot is still tentatively held for up to 15 minutes from when you picked it - complete payment before then and your booking is confirmed. Otherwise the slot is released automatically."}
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to={retryTarget} data-testid="payment-cancel-retry" className="btn-primary">
              {eventUri && inviteeUri ? "Complete payment" : "Try booking again"}
            </Link>
            <Link to="/contact" data-testid="payment-cancel-contact" className="btn-secondary">Contact the clinic</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
